import { render } from "./WordsBasic.vue?vue&type=template&id=10a156cd&scoped=true&ts=true"
import script from "./WordsBasic.vue?vue&type=script&lang=ts"
export * from "./WordsBasic.vue?vue&type=script&lang=ts"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a156cd"]])

export default __exports__